export const DISPLAY_PRO_POST_DOWNLOAD_PAGE = 'displayProPostDownloadPage'
export const DISPLAY_SCALABLE_TEMPLATES = 'show_scalable_templates'
export const SHOW_INACCURATE_WARNING = 'show_inaccurate_data_warning'
export const CODE_MANAGEMENT_TOP_NAV_PRO_UPSELL = 'code_management_pro_upsell_banner'
export const VIDEO_INSERTION_TOOL_BANNER = 'video_insertion_tool_banner'
export const CANVA_BANNER = 'canva_banner'
export const SHOW_PRINT_STORES_NEARBY = 'show_print_stores_nearby'
export const FLOWTAG_DEFAULT_CRM = 'flowtag_default_crm'
export const PRINT_STORE_SHOPPING_CART = 'print_store_shopping_cart'
export const PRINT_STORE_DISCOUNT_UPSELL = 'print_store_discount_upsell'
export const FLOWLYTICS_TOP_METRICS_ALL_TIME_OPTION = 'flowlytics_top_metrics_all_time_option'
export const QUICKER_DELIVERY = 'quicker_delivery'
export const HOMEPAGE_BUTTON_2_COPY_Q4_2022 = 'homepage_button_2_copy_q4_2022'
export const HOMEPAGE_SCROLL_BUTTON_TEST_20 = 'test_20_homepage_scroll_button'
export const FLOWCODE_MANAGEMENT_EDIT_CODE_DESIGN = 'flowcode_management_edit_code_design'
export const JOURNEY_STO_EMAIL_COLLECTION_USECASE_INDUSTRY =
  'journey_sto_email_collection_usecase_industry'
export const TEST_STATIC_IMAGE_TO_REPLACE_ANIMATION = 'test_static_image_to_replace_animation'
export const REDUCE_COLORS_FC_DESKTOP_GENERATOR = 'reduce_colors_fc_desktop_generator'
export const SINGULAR_CREATE_BUTTON = 'singular_create_button'
export const ACTIVATION_PAGE_V1 = 'activation_activation_page_v1'
export const QUICK_LINK_BUY_PRO = 'quick_link_buy_pro'
export const SHOW_PRO_UPSELL_BANNER = 'show_pro_upsell_banner'
